import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLeaf, 
  faSolarPanel, 
  faChartLine, 
  faLightbulb,
  faRecycle,
  faPlug
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const EnergietechnikPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faLeaf} />
            </div>
            <h1>Energietechnik</h1>
            <p>
              Nachhaltige und effiziente Energielösungen für Ihr Gebäude
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Energieeffiziente Gebäudetechnik</h2>
            <p>
              Im Bereich Energietechnik bietet das Ingenieurbüro Neubaur innovative und nachhaltige Lösungen 
              für die Energieversorgung und -optimierung von Gebäuden. Wir planen energieeffiziente Systeme, 
              die Ressourcen schonen und Betriebskosten senken.
            </p>
            <p>
              Unsere Planungen berücksichtigen aktuelle Normen und Vorschriften sowie zukünftige Entwicklungen, 
              um langfristig wirtschaftliche und umweltfreundliche Lösungen zu schaffen.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Energietechnik</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faSolarPanel} />
                </div>
                <h3 className="service-feature-title">Erneuerbare Energien</h3>
                <p className="service-feature-text">
                  Planung von Photovoltaikanlagen, Solarthermie und anderen erneuerbaren Energiesystemen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faChartLine} />
                </div>
                <h3 className="service-feature-title">Energiemanagement</h3>
                <p className="service-feature-text">
                  Konzeption und Planung von Energiemanagementsystemen zur Optimierung des Energieverbrauchs.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faLightbulb} />
                </div>
                <h3 className="service-feature-title">Energieeffiziente Beleuchtung</h3>
                <p className="service-feature-text">
                  Planung energiesparender Beleuchtungskonzepte mit LED-Technik und intelligenter Steuerung.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faRecycle} />
                </div>
                <h3 className="service-feature-title">Energetische Sanierung</h3>
                <p className="service-feature-text">
                  Konzepte zur energetischen Sanierung bestehender Gebäude und technischer Anlagen.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faPlug} />
                </div>
                <h3 className="service-feature-title">Ladeinfrastruktur</h3>
                <p className="service-feature-text">
                  Planung von Ladeinfrastruktur für Elektrofahrzeuge in Wohn- und Gewerbegebäuden.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Ansatz</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Analyse des Energiebedarfs</h3>
                  <p className="process-text">
                    Wir analysieren den aktuellen und zukünftigen Energiebedarf Ihres Gebäudes oder Projekts.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Konzeptentwicklung</h3>
                  <p className="process-text">
                    Basierend auf der Analyse entwickeln wir ein maßgeschneidertes Energiekonzept.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Detailplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte Planungen für alle energietechnischen Anlagen und Systeme.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Wirtschaftlichkeitsbetrachtung</h3>
                  <p className="process-text">
                    Wir berechnen die Wirtschaftlichkeit der geplanten Maßnahmen und zeigen Einsparpotenziale auf.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Umsetzungsbegleitung</h3>
                  <p className="process-text">
                    Wir begleiten die Umsetzung der energietechnischen Maßnahmen bis zur Inbetriebnahme.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Energieeffizienz für Ihr Projekt</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich Energietechnik für Ihr nächstes Projekt. 
              Wir beraten Sie gerne zu nachhaltigen und wirtschaftlichen Energielösungen.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default EnergietechnikPage;
